import "./CommandTab.css";
import { CommandContextStore } from "../context/CommandContext";
import {
    IconButton,
    Paper,
    Box,
    Tabs,
    Tab,
    Typography
} from "@mui/material";
import ContentCopy from "@mui/icons-material/ContentCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import React from "react";
import { styled } from '@mui/material/styles';
import ReactGA from 'react-ga';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const Item = styled(Paper)(({ theme }) => ({
    // style={{ padding: 20, color: "#5E5C61", background: "#E3E3E3", position: "relative", display: "flex", border: "1px solid rgba(130, 129, 132, .4)", borderRadius: '2px' }}
    ...theme.typography.body2,
    // padding: theme.spacing(1),
    display: "flex",
    padding: '20px',
    textAlign: 'center',
    color: theme.palette.text.commandBox,
    borderRadius: '2px',
    background: "rgba(227,227,227, .4)",
    mixBlendMode: 'normal',
    border: "1px solid rgba(130, 129, 132, .4)",
    position: "relative",
    boxShadow: "none",
}));

// Expected section example
// {
//     "name": "Section Name",
//     "commands": [
//         {
//             "command": "Command1",
//             "language": "EXE"
//         },
//         {
//             "command": "Command2",
//             "language": "PS"
//         }
//     ],
//     "mitre": "T1590.001"
// }
export const CommandTab = ({ section, onMount }) => {
    const [value, setValue] = React.useState(0);
    const [style, setStyle] = React.useState({ display: "none" })
    const commandContext = React.useContext(CommandContextStore);
    const [isMounted, setIsMounted] = React.useState(false);

    React.useEffect(() => {
        //console.log("COMMAND TAB MOUNT");
        setIsMounted(true);
        return () => {
          setIsMounted(false);
        };
      }, []);

    React.useEffect(() => {
    if (isMounted) {
        // Notify the parent component that this CommandTab has mounted
        onMount();
        }
      }, [isMounted]);      

    React.useEffect(() => {
        setValue(0);
    }, [section])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleClick = (cmd) => {
        ReactGA.event({
            category: "Commands",
            action: "Use command",
            label: cmd
        })
        commandContext.dispatch({ type: "COPIED", data: Date.now() })
    }

    return (
        <>
            {/* Title */}
            <div className={`command-title ${`command${section.index}` === window.location.hash.slice(1) ? 'highlighted' : ''}`}>
                {section.name}

                {section.mitre &&
                    <a href={`https://attack.mitre.org/techniques/${section.mitre.replace('.', '/')}`}
                        rel="noopener noreferrer"
                        target="_blank"
                        className="mitre-link">MITRE</a>
                }
            </div>
            {/* Map language tabs for command template */}
            <Box>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons={false}
                    allowScrollButtonsMobile
                    aria-label="scrollable force tabs example"
                    style={{ borderBottom: '2px solid rgba(227,227,227,0.699301)' }}
                >
                    {section.commands.map((command, i) => {
                        return (<Tab key={i} label={command.language} />)
                    })}
                </Tabs>
            </Box>

            {/* Map commands template for tabs */}
            {section.commands.map((command, index) => {
                return (
                    <TabPanel key={index} value={value} index={index}>
                        <Item
                            onMouseEnter={e => { setStyle({ display: "flex" }) }}
                            onMouseLeave={e => { setStyle({ display: "none" }) }}
                        >
                            <CopyToClipboard text={command.command} >
                                <IconButton
                                    className="codeblock"
                                    onClick={() => { handleClick(section.name) }}
                                    style={style}>
                                    <ContentCopy color="copyButton" />
                                </IconButton>
                            </CopyToClipboard>

                            <Typography className="command-text" >
                                {command.command}
                            </Typography>
                        </Item>
                    </TabPanel>
                )
            })}
        </>
    );
};
